// postfix JE - jQuery Element
(function () {
	const categories = () => {
		$(document).ready(function () {
			$(".categories-list").each(function (index, parent) {
				let parentId = `#${$(parent).attr("id")}`;
              console.log(parentId);
				// prettier-ignore
				let categoriesCarousel = document.querySelector(parentId).querySelector(`.js-ts-slider`);
				// prettier-ignore
				let categoriesCarouselNext = document.querySelector(parentId).querySelector(".js-ts-slider__arrow--next");
				// prettier-ignore
				let categoriesCarouselPrev = document.querySelector(parentId).querySelector(".js-ts-slider__arrow--prev");

				// prettier-ignore
				let categoriesSlider = document.querySelector(parentId).querySelector(`.js-swiper-categories`);
				// prettier-ignore
				let categoriesSliderNext = document.querySelector(parentId).querySelector(".js-categories-carousel-arrow-prev");
				// prettier-ignore
				let categoriesSliderPrev = document.querySelector(parentId).querySelector(".js-categories-carousel-arrow-next");
				// prettier-ignore
				let categoriesSliderScrollBar = document.querySelector(parentId).querySelector(".js-categories-swiper-scrollbar");
				// prettier-ignore
				//let categoriesSliderPagination = document.querySelector(parentId).querySelector(".js-categories-swiper-scrollbar");

				const Carousel = new Swiper(categoriesCarousel, {
					parallax: true,
					slidesPerView: 1,
					centeredSlides: true,
					speed: 1000,
					navigation: {
						prevEl: categoriesCarouselPrev,
						nextEl: categoriesCarouselNext,
					},
				});

				//
				const Slider = new Swiper(categoriesSlider, {
					slidesPerView: 4,
					slidesPerGroup: 4,
					centeredSlides: false,
					speed: 1000,

					navigation: {
						prevEl: categoriesSliderPrev,
						nextEl: categoriesSliderNext,
					},

					scrollbar: {
						el: categoriesSliderScrollBar,
						draggable: true,
					},

					breakpoints: {
						0: {
							slidesPerView: 1,
							slidesPerGroup: 1,
						},

						920: {
							slidesPerView: 2,
							slidesPerGroup: 2,
						},

						1100: {
							slidesPerView: 3,
							slidesPerGroup: 3,
						},
						1300: {
							slidesPerView: 4,
							slidesPerGroup: 4,
						},
						1500: {
							slidesPerView: 4,
							// slidesPerGroup: 3,
						},
						1800: {
							slidesPerView: 4,
							// slidesPerGroup: 3,
						},
					},
				});
				if (document.querySelector(".categories_nav-tools")) {
					if (
						categoriesSliderNext &&
						categoriesSliderNext.hasAttribute("disabled") &&
						categoriesSliderPrev.hasAttribute("disabled")
					) {
						document.querySelector(".categories_nav-tools").style.display =
							"none";
					} else {
						document.querySelector(".categories_nav-tools").style.display =
							"flex";
					}
				}
			});
		});
	};

	//.js-swiper-product-carousel
	document.addEventListener("DOMContentLoaded", function () {
		categories();
		document.addEventListener("shopify:section:load", function () {
			categories();
		});
	});

	window.addEventListener("resize", function () {
		categories();
	});
})();
